export default __webpack_public_path__ + "static/media/main_final_jr.7cfb13d6.mp3";